// extracted by mini-css-extract-plugin
module.exports = {"FormBenefitsBox":"FormBenefitsBox_FormBenefitsBox__YGcLn","_FormBenefitsBox":"FormBenefitsBox__FormBenefitsBox__2CK4j","title":"FormBenefitsBox_title__2mTgN"};